import { ADMIN_MANAGEMENT_COMPANIES_ENDPOINTS, AdminManagementCompaniesService } from "@/service/api/admin-management-companies";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { toast } from "react-toastify";

const useDemoTemplateModules = (enabled = true) => {
  const query = useQuery({
    queryKey: [ADMIN_MANAGEMENT_COMPANIES_ENDPOINTS.GET_DEMO_TEMPLATE_MODULES],
    queryFn: AdminManagementCompaniesService.getDemoTemplateModules,
    enabled,
    retry: false,
  });

  useEffect(() => {
    if (query.isError) {
      toast.error(query.error?.message || "Erro ao carregar módulos de demonstração.");
    }
  }, [query.isError, query.error]);

  return query;
};

export default useDemoTemplateModules;
